module.exports = __webpack_public_path__ + "static/media/back_green.6db48502.png";